import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import "./Measurement_Uncertainty_Form.css";
import {
  AllParameter,
  allSampleManagement,
  allTestedBy,
} from "../../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Select from "react-select";
import {
  Create,
  GetAll,
} from "../../../../../../../../../src/features/admin/quality_management/process_requirement/measurement_uncertainty/Slice";

function Measurement_Uncertainty_Form({ onNext, fetchCustomers }) {
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset,
    setError,
    clearErrors,
    setValue,
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      observations: [{ value: "" }],
    },
  });
  const dispatch = useDispatch();

  const all_parameter = useSelector((state) => state.common.all_parameter);

  const all_tested_by = useSelector((state) => state.common.all_teseted_by);
  useEffect(() => {
    dispatch(AllParameter());
    dispatch(allTestedBy());
  }, [dispatch]);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "observations",
  });

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("user_id", data.user_id);
      formData.append("sample_id", data.sample_management_id);
      formData.append("parameter_id", data.parameter_id);
      formData.append("measurement_period", data.measurement_period);
      formData.append("observation_value", data.observation_value);
      formData.append("standard_deviation", data.standard_deviation);
      formData.append("standard_uncertainity", data.standard_uncertainity);
      formData.append("type_b_uncertainity", data.type_b_uncertainity);
      formData.append("combined_uncertainity", data.combined_uncertainity);
      formData.append("attach_file", data.attach_file[0]);
      formData.append("remark", data.remark);
      data?.observations?.forEach((o, i) => {
        formData.append(`observations[${i}]`, o.value);
      });

      const res = await dispatch(Create(formData));
      if (res.meta.requestStatus === "fulfilled") {
        // await dispatch(GetAll());
        await fetchCustomers();
        reset();
        onNext();
      }
    } catch (error) {
      console.error("Measurement Uncertainty Submit Error:", error);
    }
  };
  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );

  useEffect(() => {
    dispatch(allSampleManagement());
  }, [dispatch]);

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        {/* Measurement Period */}
        <div className="row mb-3">
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Parameter</Form.Label>
              <Controller
                name="parameter_id"
                control={control}
                rules={{ required: "Parameter is required" }}
                render={({ field }) => (
                  <Select
                    options={all_parameter}
                    value={
                      all_parameter?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.parameter_id && (
                <Form.Text className="text-danger">
                  {errors.parameter_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Controller
                name="sample_management_id"
                control={control}
                rules={{ required: "Sample is required" }}
                render={({ field }) => (
                  <Select
                    options={all_sample_management}
                    value={
                      all_sample_management?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.sample_management_id && (
                <Form.Text className="text-danger">
                  {errors.sample_management_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group">
              <Form.Label>Tested By</Form.Label>
              <Controller
                name="user_id"
                control={control}
                rules={{ required: "Tested By is required" }}
                render={({ field }) => (
                  <Select
                    options={all_tested_by}
                    value={
                      all_tested_by?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.user_id && (
                <small className="text-danger">{errors.user_id.message}</small>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Measurement Period</Form.Label>
              <Form.Control
                placeholder="Measurement Period"
                {...register("measurement_period", {
                  required: "Measurement period is required",
                  // pattern: {
                  //   value: /^[0-9]+$/,
                  //   message: "Only numbers are allowed",
                  // },
                  // min: {
                  //   value: 1,
                  //   message: "Must be greater than 0",
                  // },
                  // max: {
                  //   value: 3650,
                  //   message: "Too large value",
                  // },
                })}
                // onKeyDown={(e) => {
                //   const value = e.target.value;

                //   // Allow control keys
                //   if (
                //     [
                //       "Backspace",
                //       "Delete",
                //       "Tab",
                //       "ArrowLeft",
                //       "ArrowRight",
                //     ].includes(e.key)
                //   ) {
                //     return;
                //   }

                //   // Allow numbers
                //   if (/^[0-9]$/.test(e.key)) {
                //     return;
                //   }

                //   // Allow ONE decimal point
                //   if (e.key === "." && !value.includes(".")) {
                //     return;
                //   }

                //   // Block everything else
                //   e.preventDefault();
                // }}
              />

              {errors.measurement_period && (
                <Form.Text className="text-danger">
                  {errors.measurement_period.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Enter Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>

        <div className="heading_add_text mt-3">
          <Form.Group className="form_group">
            <Form.Label>Enter Observation</Form.Label>
          </Form.Group>
          <span onClick={() => append({ value: "" })}>
            <FontAwesomeIcon icon={faCirclePlus} /> Add Observation
          </span>
        </div>
        <div className="row">
          {fields.map((field, index) => (
            <div key={field.id} className="col-xl-2 col-lg-4  col-md-4">
              <div className="observation_box">
                <div className="obs_label">
                  OBS {String(index + 1).padStart(2, "0")}
                </div>

                <Form.Control
                  {...register(`observations.${index}.value`, {
                    required: "Observation is required",
                  })}
                  onKeyDown={(e) => {
                    const value = e.target.value;

                    // Allow control keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                      ].includes(e.key)
                    ) {
                      return;
                    }

                    // Allow numbers
                    if (/^[0-9]$/.test(e.key)) {
                      return;
                    }

                    // Allow ONE decimal point
                    if (e.key === "." && !value.includes(".")) {
                      return;
                    }

                    // Block everything else
                    e.preventDefault();
                  }}
                />

                {errors.observations?.[index]?.value && (
                  <small className="text-danger">
                    {errors.observations[index].value.message}
                  </small>
                )}

                {fields.length > 1 && (
                  <button type="button" onClick={() => remove(index)}>
                    ❌
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        {errors.observations?.message && (
          <div className="text-danger mb-2">{errors.observations.message}</div>
        )}
        {/* TABLE DESIGN (Same Pattern as Listing Table) */}
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table customer_table measurement_input_table">
              <thead>
                <tr>
                  {/* <th>Observation Value</th> */}
                  <th>Standard Deviation</th>
                  <th>Standard Uncertainity</th>
                  <th>Reported Uncertainty </th>
                  <th>Combined Uncertainity</th>
                  <th>Attach File</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  {/* <td>
                    <Form.Control
                      placeholder="Value"
                      {...register("observation_value", {
                        required: "Observation value is required",
                      })}
                    />
                  </td> */}

                  <td>
                    <Form.Control
                      placeholder="Value"
                      {...register("standard_deviation", {
                        required: "Standard deviation is required",
                      })}
                      onKeyDown={(e) => {
                        const value = e.target.value;

                        // Allow control keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Allow numbers
                        if (/^[0-9]$/.test(e.key)) {
                          return;
                        }

                        // Allow ONE decimal point
                        if (e.key === "." && !value.includes(".")) {
                          return;
                        }

                        // Block everything else
                        e.preventDefault();
                      }}
                    />
                    {errors.standard_deviation && (
                      <Form.Text className="text-danger">
                        {errors.standard_deviation.message}
                      </Form.Text>
                    )}
                  </td>

                  <td>
                    <Form.Control
                      placeholder="Value"
                      {...register("standard_uncertainity", {
                        required: "Standard uncertainty is required",
                      })}
                      onKeyDown={(e) => {
                        const value = e.target.value;

                        // Allow control keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Allow numbers
                        if (/^[0-9]$/.test(e.key)) {
                          return;
                        }

                        // Allow ONE decimal point
                        if (e.key === "." && !value.includes(".")) {
                          return;
                        }

                        // Block everything else
                        e.preventDefault();
                      }}
                    />
                    {errors.standard_uncertainity && (
                      <Form.Text className="text-danger">
                        {errors.standard_uncertainity.message}
                      </Form.Text>
                    )}
                  </td>

                  <td>
                    <Form.Control
                      placeholder="Value"
                      {...register("type_b_uncertainity", {
                        required: "Type B uncertainty is required",
                      })}
                      onKeyDown={(e) => {
                        const value = e.target.value;

                        // Allow control keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Allow numbers
                        if (/^[0-9]$/.test(e.key)) {
                          return;
                        }

                        // Allow ONE decimal point
                        if (e.key === "." && !value.includes(".")) {
                          return;
                        }

                        // Block everything else
                        e.preventDefault();
                      }}
                    />
                    {errors.type_b_uncertainity && (
                      <Form.Text className="text-danger">
                        {errors.type_b_uncertainity.message}
                      </Form.Text>
                    )}
                  </td>

                  <td>
                    <Form.Control
                      placeholder="Value"
                      {...register("combined_uncertainity", {
                        required: "Combined uncertainty is required",
                      })}
                      onKeyDown={(e) => {
                        const value = e.target.value;

                        // Allow control keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Allow numbers
                        if (/^[0-9]$/.test(e.key)) {
                          return;
                        }

                        // Allow ONE decimal point
                        if (e.key === "." && !value.includes(".")) {
                          return;
                        }

                        // Block everything else
                        e.preventDefault();
                      }}
                    />
                    {errors.combined_uncertainity && (
                      <Form.Text className="text-danger">
                        {errors.combined_uncertainity.message}
                      </Form.Text>
                    )}
                  </td>

                  {/* FILE UPLOAD */}
                  <td className="text-center">
                    {/* <span
                      className="upload_link red_text"
                      onClick={() => fileInputRef.current.click()}
                    >
                      <FontAwesomeIcon icon={faUpload} /> Upload File
                    </span> */}

                    <Form.Control
                      type="file"
                      {...register("attach_file", {
                        required:
                          typeof getValues("attach_file") === "string"
                            ? false
                            : "File is required",
                      })}
                      accept="*"
                    />
                    {errors.attach_file && (
                      <span className="text-danger">
                        {errors.attach_file.message}
                      </span>
                    )}
                    {(() => {
                      const fileValue = watch("attach_file");

                      // URL for preview
                      const fileUrl =
                        typeof fileValue === "string"
                          ? process.env.REACT_APP_IMG_URL + fileValue
                          : fileValue?.length > 0
                          ? URL.createObjectURL(fileValue[0])
                          : null;

                      // Type detection
                      const fileType =
                        typeof fileValue === "string"
                          ? fileValue.toLowerCase()
                          : fileValue?.[0]?.type;

                      if (!fileUrl) return null;

                      return (
                        <div className="image_holder">
                          {/* IMAGE */}
                          {(fileType?.includes("image") ||
                            fileType?.endsWith(".jpg") ||
                            fileType?.endsWith(".jpeg") ||
                            fileType?.endsWith(".png")) && (
                            <img
                              src={fileUrl}
                              alt="Preview"
                              className="image-preview"
                              style={{ maxWidth: "150px" }}
                            />
                          )}

                          {/* PDF */}
                          {(fileType === "application/pdf" ||
                            fileType?.endsWith(".pdf")) && (
                            <iframe
                              src={fileUrl}
                              style={{ maxWidth: "100px" }}
                              title="PDF"
                            />
                          )}

                          {/* WORD */}
                          {(fileType?.includes("word") ||
                            fileType?.endsWith(".doc") ||
                            fileType?.endsWith(".docx")) && (
                            <div>
                              <p>Word preview not supported</p>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open / Download Word File
                              </a>

                              <iframe
                                src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                                style={{ maxWidth: "100px" }}
                                title="Word Preview"
                              />
                            </div>
                          )}

                          {/* EXCEL */}
                          {(fileType?.includes("spreadsheet") ||
                            fileType?.endsWith(".xlsx") ||
                            fileType?.endsWith(".xls")) && (
                            <div>
                              <p>Excel preview not supported</p>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open / Download Excel File
                              </a>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Buttons */}
        <div className="permission_btn_holder mt-4">
          <Button className="permission_btn No_btn">Reset</Button>
          <Button
            className="permission_btn Yes_btn"
            onClick={handleSubmit(onSubmit)}
          >
            Save & Next
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Measurement_Uncertainty_Form;
